// @flow
import Loadable from 'react-loadable'

import Loader from '@src/components/ui/ReactLoadableLoader'

const OrderLoader = Loadable({
  loader: () => import('./OrderContainer'),
  loading: Loader,
})

export default OrderLoader
